import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";

import { Button, Form, message, notification, Tooltip, Upload } from "antd";
import TextInput from "../Common/UITextInput/TextInput";
import "../PartnerManagement/Style.css";
import useWindowSize from "../../utils/useWindowSize";

import Logout from "../../containers/Pages/Login/Logout";
import { connect } from "react-redux";

import LeadManagementListing from "./leadManagementListing/LeadManagementListing";
import "./LeadManagement.css";
import LeadUploadStepper from "./LeadUploadStepper";
import ChangePassword from "../../containers/Pages/Login/ChangePassword";
import img from "../../images/Group 128.png";
import useSession from "../CustomLogout/useSession";
import { leadActivationDetailsDetails } from "../../redux/LeadManagement/actions";
import GlobalLeadSearch from "../GlobalLeadSearch/GlobalLeadSearch";
import UiButton from "../Common/UiButton/UiButton";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  DownloadOutlined,
  InfoCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Lead_Service_URL } from "../../redux/Url";
import { useSelector } from "react-redux";

const FormItem = Form.Item;

const LeadManagement = (props) => {
  const { width } = useWindowSize();
  const handleSessionExpired = useSession();

  const qualificationType = useSelector(
    (state) =>
      state?.dashboardReducer?.dashboardDetails?.data?.dto?.qualifiedPartner
  );

  const partnerDisplayCode = useSelector(
    (state) =>
      state.dashboardReducer?.dashboardDetails?.data?.dto?.partnerDisplayCode
  );

  const userId = useSelector((state) => state?.auth?.userId);

  const [openUploadStepper, setUploadStepper] = useState(false);
  const [partnerRefresh, setPartnerRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [taskStatus, setTaskStatus] = useState(null);
  const [errorReason, setErrorReason] = useState(null);
  const [batchFailed, setBatchFailed] = useState(null);
  const [taskId, setTaskId] = useState(null);
  const [processedRecord, setProcessedRecord] = useState("");
  const [unProcessedRecord, setUnProcessedRecord] = useState("");

  const history = useNavigate();

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const closeLeadUploadStepper = () => setUploadStepper(false);
  const [leadActivationId, setLeadActivationId] = useState();

  function goLead() {
    history("/leadManagementDashboard/addLead");
  }
  useEffect(() => {
    props
      .leadActivationDetailsDetails({
        access_token: props?.accessToken,
        partnerFirmId: props?.firmId,
      })
      .then((res) => {
        if (res?.status === 200) {
          setLeadActivationId(res?.data?.dto?.leadActivationFlag);
          setLoading(false);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          setLoading(false);

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            setLoading(false);
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, [props?.state]);

  const handleUpload = async (options) => {
    const { file } = options;
    const formData = new FormData();
    formData.append("file", file);

    setTaskStatus("");
    setProcessedRecord("");
    setUnProcessedRecord("");
    setErrorReason([]);
    setBatchFailed(false);

    setUploadLoading(true);
    try {
      const response = await axios.post(
        `${Lead_Service_URL}/importLeadMasterData?partner_display_code=${partnerDisplayCode}&user_id=${userId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${props?.accessToken}`,
          },
        }
      );

      if (response.data?.success?.status === "200") {
        message.success("File uploaded successfully!");
        setTaskId(response.data.taskId);
      } else {
        message.error("Upload failed. Please try again.");
      }
    } catch (error) {
      message.error("Error uploading file.");
    } finally {
      setUploadLoading(false);
    }
  };

  const checkTaskStatus = async (taskId) => {
    try {
      const response = await axios.post(
        `${Lead_Service_URL}/get/importLeadMasterData/taskStatus?taskId=${taskId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${props?.accessToken}`,
          },
        }
      );

      if (response.data?.success?.status === "200") {
        setTaskStatus(response.data.response.status);

        const parsedResults = JSON.parse(response?.data?.response?.results);

        setProcessedRecord(
          parsedResults?.responseInBatch[0].rowsProcessedWithSuccess
        );

        const errorMessagesArray = Object.entries(
          parsedResults?.responseInBatch[0].unprocessedRowsDetails
        ).map(([cellNo, message]) => {
          const reason = message.split("Reason:")[1]?.trim();
          return `Cell no ${cellNo} - ${reason}`;
        });

        setUnProcessedRecord(errorMessagesArray.length);
        setErrorReason(errorMessagesArray);

        setBatchFailed(
          parsedResults?.responseInBatch[0].doesBatchFailedWithException
        );
        if (parsedResults?.responseInBatch[0].doesBatchFailedWithException) {
          setProcessedRecord(0);
          setUnProcessedRecord(
            parseInt(parsedResults?.responseInBatch[0].batchInfo.endRow) -
              parseInt(parsedResults?.responseInBatch[0].batchInfo.startRow)
          );
        }
      } else {
        message.error("Failed to fetch task status.");
      }
    } catch (error) {
      console.error("Actual Error:", error);
    }
  };

  const handleDownload = async () => {
    try {
      const response = await axios.get(
        `${Lead_Service_URL}/downloadImportLeadMasterCsvTemplate`,
        {
          headers: {
            Authorization: `Bearer ${props?.accessToken}`,
          },
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "LeadMasterTemplate.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      message.error("Download failed");
    }
  };

  if (leadActivationId) {
    // eslint-disable-next-line default-case
    switch (openUploadStepper) {
      case false:
        return (
          <div className="" style={{ maxWidth: "100%" }}>
            {width < 786 && (
              <Row>
                <Col lg={12} xs={12} md={12} sm={12}>
                  <FormItem
                    name="PartnerManagementsearch"
                    colon={false}
                    rules={[
                      {
                        required: false,
                        message: "Please Select Partner Management Search",
                      },
                    ]}
                    className="m-0 p-0"
                  >
                    <TextInput
                      type="search"
                      placeholder="Search Partner, Lead, Employee"
                    />
                  </FormItem>
                </Col>
              </Row>
            )}
            <section className="header-container">
              {width > 786 && (
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="partnerHeadre"
                  >
                    <Col md={8} className="search-bar"></Col>

                    <Col md={4}>
                      <div className="login-profie">
                        <div className="img-sec">
                          <h2>
                            {adminFirstName(
                              props.userDetail?.firstName ??
                                props.userDetail?.userName
                                  ?.split(" ")[0]
                                  ?.trim()
                            )}
                          </h2>
                          <h2>
                            {adminLastName(
                              props.userDetail?.lastName ??
                                props.userDetail?.userName
                                  ?.split(" ")[1]
                                  ?.trim()
                            )}
                          </h2>
                        </div>

                        <div className="content-login">
                          <h4>{props.userDetail?.userName}</h4>
                          <h5>{props.userDetail?.roleName}</h5>
                          <div className="content-login-data">
                            <ChangePassword />
                            <div className="admin-small-space"> </div>
                            <Logout />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Col>
                </Row>
              )}

              <Row>
                <Col md={8} className="btn-partner">
                  <Row className="d-flex align-items-center">
                    <Col calssName="AddLeadManin" md={3}>
                      <UiButton
                        title="Add Lead"
                        // type="submit"
                        onClick={goLead}
                        className="Addleadmain"
                      />
                    </Col>

                    <Col md={3} className="ButtonSet">
                      <GlobalLeadSearch
                        listingRefresh={partnerRefresh}
                        setListingRefresh={setPartnerRefresh}
                      />
                    </Col>
                    {qualificationType === "BOTH" ||
                    qualificationType === "LEAD" ? (
                      <>
                        <Col md={3} className="ButtonSet">
                          <Upload
                            customRequest={handleUpload}
                            showUploadList={false}
                            accept=".csv"
                            beforeUpload={(file) => {
                              const isCSV =
                                file.type === "text/csv" ||
                                file.name.endsWith(".csv");
                              if (!isCSV) {
                                message.error("Only CSV files are allowed!");
                              }
                              return isCSV || Upload.LIST_IGNORE;
                            }}
                          >
                            <Button
                              className="btn-upload"
                              icon={<UploadOutlined />}
                              loading={uploadLoading}
                            >
                              {uploadLoading ? "Uploading..." : "Bulk Upload"}
                            </Button>
                          </Upload>
                          {/* {processingTime && (
                          <span>
                            Estimated Processing Time: {processingTime}
                          </span>
                        )} */}
                        </Col>
                        <Col md={3}>
                          <Button
                            className="btn-download-template"
                            icon={<DownloadOutlined />}
                            onClick={handleDownload}
                          >
                            Download Template
                          </Button>
                        </Col>
                        {taskId && taskStatus !== "COMPLETED" ? (
                          <Col md={3}>
                            <Button
                              className="btn-check-status"
                              onClick={() => {
                                if (taskId) checkTaskStatus(taskId);
                              }}
                            >
                              Check Status
                            </Button>
                          </Col>
                        ) : null}
                        {taskStatus && (
                          <div className="status-section-container">
                            <div className="lead-management-status">
                              <span className="lead-management-label-decor-status">
                                Status
                                {taskStatus === "PROCESSING" && (
                                  <Tooltip
                                    title="Please check status until completed."
                                    placement="top"
                                  >
                                    <InfoCircleOutlined
                                      style={{
                                        marginLeft: 3,
                                        marginRight: 2,
                                        fontSize: 14,
                                        color: "#00b1b1",
                                        position: "relative",
                                        top: 1,
                                      }}
                                    />
                                  </Tooltip>
                                )}
                                :
                              </span>
                              <span className="lead-management-label-value">
                                {taskStatus === "PROCESSING" ? (
                                  <>
                                    Processing
                                    <span className="blinking-dots">
                                      <span>.</span>
                                      <span>.</span>
                                      <span>.</span>
                                    </span>
                                  </>
                                ) : (
                                  taskStatus
                                )}
                              </span>
                            </div>
                            <div className="status-section lead-management-status">
                              <div>
                                <span className="lead-management-label-decor">
                                  Processed Records:
                                </span>
                                <span className="lead-management-label-value">
                                  {processedRecord}
                                </span>
                              </div>
                              <div>
                                <span className="lead-management-label-decor">
                                  Unprocessed Records:
                                </span>
                                <span className="lead-management-label-value">
                                  {unProcessedRecord}
                                </span>
                              </div>
                            </div>

                            {batchFailed ? (
                              <div className="test">
                                <span className="lead-management-label-error">
                                  Error Reason:
                                </span>
                                There seems to be an issue with the file data.
                                Please check and reupload the file again.
                              </div>
                            ) : errorReason?.length > 0 ? (
                              errorReason?.map((item) => (
                                <div className="test">
                                  <span className="lead-management-label-error">
                                    Error Reason:
                                  </span>
                                  {item}
                                </div>
                              ))
                            ) : null}
                          </div>
                        )}
                      </>
                    ) : null}
                  </Row>
                </Col>
              </Row>
            </section>

            <Row style={{ maxWidth: "100%" }}>
              <Col md={12} style={{ maxWidth: "100%", overflow: "hidden" }}>
                <LeadManagementListing
                  partnerRefresh={partnerRefresh}
                  setPartnerRefresh={setPartnerRefresh}
                />
              </Col>
            </Row>
          </div>
        );
      case true:
        return (
          <LeadUploadStepper
            adminFirstName={adminFirstName}
            adminLastName={adminLastName}
            userDetail={props.userDetail}
            closeLeadUploadStepper={closeLeadUploadStepper}
            {...props}
          />
        );
    }
  } else {
    return (
      <>
        <div className="" style={{ maxWidth: "100%" }}>
          {width < 786 && (
            <Row>
              <Col lg={12} xs={12} md={12} sm={12}>
                <FormItem
                  name="PartnerManagementsearch"
                  colon={false}
                  rules={[
                    {
                      required: false,
                      message: "Please Select Partner Management Search",
                    },
                  ]}
                  className="m-0 p-0"
                >
                  <TextInput
                    type="search"
                    placeholder="Search Partner, Lead, Employee"
                  />
                </FormItem>
              </Col>
            </Row>
          )}

          {width > 786 && (
            <Row>
              <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
                <Col md={8} className="search-bar"></Col>

                <Col md={4}>
                  <div className="login-profie">
                    <div className="img-sec">
                      <h2>
                        {adminFirstName(
                          props.userDetail?.firstName ??
                            props.userDetail?.userName?.split(" ")[0]?.trim()
                        )}
                      </h2>
                      <h2>
                        {adminLastName(
                          props.userDetail?.lastName ??
                            props.userDetail?.userName?.split(" ")[1]?.trim()
                        )}
                      </h2>
                    </div>

                    <div className="content-login">
                      <h4>{props.userDetail?.userName}</h4>
                      <h5>{props.userDetail?.roleName}</h5>
                      <div className="content-login-data">
                        <ChangePassword />
                        <div className="admin-small-space"> </div>
                        <Logout />
                      </div>
                    </div>
                  </div>
                </Col>
              </Col>
            </Row>
          )}
          {!loading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
              className="coming-Soon-sec"
            >
              <img
                src={img}
                style={{
                  height: "60vh",
                  width: "60vw",
                  objectFit: "contain",
                  margin: "auto",
                }}
              />
            </div>
          )}
        </div>
      </>
    );
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    leadActivationDetailsDetails: (data) =>
      dispatch(leadActivationDetailsDetails(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    userDetail: state.auth?.userData,
    state: state.auth,
    accessToken: state?.auth?.idToken,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadManagement);
